// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { SectionContainer, SectionTitle } from "@rc/App/Widgets/DesignSystem/DesignSystem.helpers";
import { longText } from "@rc/App/Widgets/DesignSystem/DummyData/DummyData";
import Button from "@rc/MobiusOverrides/Button/Button";
import Tooltip from "@rc/MobiusOverrides/Tooltip/Tooltip";
import React, { FC } from "react";
import { css } from "styled-components";

interface TooltipTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    tooltipWrapper?: InjectableCss;
}

const tooltipTabStyles: TooltipTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    tooltipWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = tooltipTabStyles;
const TooltipTab: FC = props => {
    const tooltipText = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Tooltip")}</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <StyledWrapper {...styles.tooltipWrapper}>
                    <StyledWrapper>
                        <Tooltip triggerComponent={<Button variant="secondary">Top without Title</Button>} text={tooltipText}/>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Tooltip placement="top" triggerComponent={<Button variant="secondary">Top</Button>} title="Tool Tip : Up" text={tooltipText}/>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Tooltip placement="bottom" triggerComponent={<Button variant="secondary">Bottom</Button>} title="Tool Tip : Dwon" text={tooltipText}/>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Tooltip placement="right" triggerComponent={<Button variant="secondary">Right</Button>} title="Tool Tip : Right" text={tooltipText}/>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Tooltip placement="left" triggerComponent={<Button variant="secondary">Left</Button>} title="Tool Tip : Left" text={tooltipText}/>
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default TooltipTab;
